const featuredCollectionsSliders = document.querySelectorAll(".section-featured-collections-slider.js");

featuredCollectionsSliders.forEach(sectionSlider => {
  const swiperContainer = sectionSlider.querySelector('.swiper');
  const sliderButtonPrev = sectionSlider.querySelector('.slider-button-prev');
  const sliderButtonNext = sectionSlider.querySelector('.slider-button-next');
  const arrows = sectionSlider.querySelector('.featured-collections-slider-arrows');
  const spaceBetween = swiperContainer.dataset.spaceBetween;
  let swiper;

  const updateSlider = () => {
    const containerWidth = sectionSlider.offsetWidth;
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const slideWidth = slides[0].offsetWidth;
    const totalSlidesWidth = slideWidth * slides.length + (slides.length - 1) * spaceBetween;

    if (containerWidth > totalSlidesWidth) {
      sectionSlider.classList.add('centered-content');
      if (swiper) {
        swiper.destroy();
        swiper = null;
      }
      if (arrows) arrows.classList.add('hidden');
      sectionSlider.style.opacity = 1;
    } else {
      sectionSlider.classList.remove('centered-content');
      if (!swiper) {
        swiper = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: spaceBetween,
          navigation: {
            prevEl: sliderButtonPrev,
            nextEl: sliderButtonNext
          }
        });

        sectionSlider.style.opacity = 1;
      }
      if (arrows) arrows.classList.remove('hidden');
    }
  };

  updateSlider();
  window.addEventListener('resize', updateSlider);

  sectionSlider.classList.remove('js');
});
